import { createApi } from "@reduxjs/toolkit/query/react";
import { apiUrls } from "constants/apiUrls";
import { baseQueryWithReAuth } from "utils/baseQueryWithReAuth";
import {
    CheckoutRequestBody,
    CheckoutResponse,
    GetPlansListRes,
} from "./types";

export const pricingApiSlice = createApi({
    reducerPath: "pricingApi",
    baseQuery: baseQueryWithReAuth,
    endpoints(builder) {
        return {
            getPlans: builder.query<GetPlansListRes, any>({
                query: () => ({
                    url: apiUrls.plans,
                    method: "GET",
                }),
            }),
            checkout: builder.mutation<CheckoutResponse, CheckoutRequestBody>({
                query: (payload) => ({
                    url: apiUrls.checkout,
                    method: "POST",
                    body: payload,
                }),
            }),
        };
    },
});

export const { useGetPlansQuery, useCheckoutMutation } = pricingApiSlice;
